import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { Directive } from '@angular/core';

/**
 * Marks the element the user grabs to drag the enclosing `sim-floating-window`. It may sit anywhere
 * inside the window, also inside a child component's template: the CDK finds the window through DI.
 */
@Directive({
  selector: '[simFloatingWindowHandle]',
  hostDirectives: [CdkDragHandle],
  host: { class: 'sim-floating-window__handle' }
})
export class SimFloatingWindowHandleDirective {}
